import { Center } from '@zorro/web/design-system';

import { SVGIconProps } from '../../types';
import classNames from './MissingDetailsIcon.module.scss';

/**
 * "Some details are missing" marker: a bordered circle with a quarter-circle
 * wedge inside it.
 *
 * Geometry mirrors the V2 Stepper's `Partial` step icon
 * (`design-system/v2/Stepper/StepperPartialIcon`) scaled from 28px to 24px, so
 * the review-card header and the stepper show the same mark (ENG-1143).
 * Both are drawn in the secondary icon colour via `currentColor`.
 */
export const MissingDetailsIcon = ({ style }: SVGIconProps) => {
  return (
    <Center style={style} classNames={classNames}>
      <svg
        xmlns="http://www.w3.org/2000/svg"
        width="24"
        height="24"
        viewBox="0 0 24 24"
        fill="none"
        aria-hidden="true"
      >
        <circle
          cx="12"
          cy="12"
          r="11.5"
          stroke="currentColor"
          strokeWidth="1"
          fill="none"
        />
        <path
          d="M12 12V2.57A9.43 9.43 0 0 1 21.43 12H12Z"
          fill="currentColor"
        />
      </svg>
    </Center>
  );
};
